import React, { useContext, useState } from 'react'
import { IoConstruct, IoHome, IoLocation, IoMailOpen, IoPerson } from 'react-icons/io5'
import { CartContext } from '../Contexts/CartContext';
import LoadingBox from './LoadingBox';
import Modal from './Modal';
// import { useApi } from './query/useApi';

const OrderForm = () => {
    
  const { cart, transport, box, total } = useContext(CartContext);

    const [ company_name, setCompany_name ] = useState('');
    const [ fullname, setFullname ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ country, setCountry ] = useState('Sénégal');
    const [ incoterm, setIncoterm ] = useState('FAS');
    const [ user_id, setUser_id ] = useState();

    // FOR MODAL
    const [ title, setTitle ] = useState("");
    const [ description, setDescription ] = useState("");

    // FOR REQUEST
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [ modalIsOpen, setModalIsOpen ] = useState(false);
  
    const closeAlertModal = () => {
      setModalIsOpen(false)
    }

    const openModal = (h2, p) => {
        setTitle(h2)
        setDescription(p)
        setModalIsOpen(true)
    }
    
    const sendCommand = async (user) => {
        // setLoading(true);
        // alert("starting...");
        try {
            const response = await fetch("https://api.sunumango.com/order/add-commands/"+user, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                mangoes: cart,
                box_id: box.id,
                transport,
                incoterm
            })
            
            });
            if (!response.ok) {
            throw new Error(response.statusText);
            }
            const data = await response.json();
            if(data.message){
              setLoading(false);
            //   alert(data.message);
            openModal("Commande envoyée avec succés ", "Vous recevrez un mail de confirmation à l'adresse "+email);
            }
        } catch (err) {
            setError(err);
            alert(error);
        } finally {
            setLoading(false);
        }
    }

    const sendData = async () => {
        setLoading(true);
        try {
            const response = await fetch("https://api.sunumango.com/user/signup", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    fullname,
                    company_name,
                    email,
                    country
                })
            });

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const data = await response.json();

            if(data.message == "User created !"){
                setUser_id(data.user_id);

                // Send orderr
                sendCommand(data.user_id);
            } else if (data.mangoes == "email already exists !"){
                openModal("Cet email est déjà utilisé", "Veuillez utiliser un autre aresse email")
            }
        } catch (err) {
            setError(err);
            setLoading(false)
            openModal("Cet email est déjà utilisé", "Veuillez utiliser un autre aresse email")
        }
    }

    const resetInputs = () => {
        setFullname('');
        setEmail('');
        setCompany_name('');
    }

    const handleSubmit = e => {
        e.preventDefault();
        if(fullname, company_name, email, country, incoterm){
            sendData();
            // resetInputs();
        } else {
            alert("Veuillex remplir tous les champs");
        }
    }

  return (
    <>
        <form onSubmit={handleSubmit} >
            <h2>Finalisez...</h2>
            <p>Remplissez le formulaire pour valider votre commande</p>

            <div className="input-box">
                <span className="icon"><IoHome /></span>
                <input type="text" value={company_name} onChange={e => setCompany_name(e.target.value)} placeholder="Nom de l'entreprise" />
            </div>

            <div className="input-box">
                <span className="icon"><IoPerson /></span>
                <input type="text" value={fullname} onChange={e => setFullname(e.target.value)} placeholder="Personne à contacter" />
            </div>

            <div className="input-box">
                <span className="icon"><IoMailOpen /></span>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Adresse e-mail" />
            </div>

            <div className="input-box">
                <span className="icon"><IoLocation /></span>
                <select value={country} onChange={e => setCountry(e.target.value)}>
                    <option value="Ghana">Ghana)</option>
                    <option value="Maroc">Maroc)</option>
                    <option value="Mauritanue">Mauritanue)</option>
                    <option value="Sénégal">Sénégal</option>
                    <option value="Belgique">Belgique</option>
                    <option value="Suisse">Suisse</option>
                    <option value="Turquie">Turquie</option>
                    <option value="Union Européenne">Union Européenne</option>
                    <option value="Canada">Canada</option>
                    <option value="Etats-Unies">Etats-Unies</option>
                </select>
            </div>

            <div className="input-box">
                <span className="icon"><IoConstruct /></span>
                <select value={incoterm} onChange={e => setIncoterm(e.target.value)}>
                    <option value="FAS">FAS (Free Alongside Ship)</option>
                    <option value="FOB">FOB (Free On Board)</option>
                </select>
            </div>

            <div className="OrderValidation">
                <div className="total">
                    <span className="subtotal">Sous total :</span>
                    <span className="amount">{total}€ HT</span>
                </div>

                <button>Envoyer la commande</button>
            </div>
        </form>
        
        {loading && <LoadingBox />}

        {
        modalIsOpen && <Modal
            onClose={closeAlertModal}
            title={title}
            description={description}
        />
        }
    </>
  )
}

export default OrderForm